export type DocumentNavigation = {
  prevId: string | null;
  nextId: string | null;
};

/**
 * Resolves the previous/next document ids relative to the current document
 * within an ordered list (the filtered document list the operator navigates).
 *
 * Returns `null` for a neighbour that does not exist — the UI uses this to
 * disable the matching navigation button at the beginning/end of the list, or
 * when the list is unavailable (e.g. the page was opened directly by URL).
 */
export const getDocumentNavigation = (
  documentIds: string[] | undefined | null,
  currentId: string | undefined | null
): DocumentNavigation => {
  if (!documentIds?.length || !currentId) {
    return { prevId: null, nextId: null };
  }

  const currentIndex = documentIds.indexOf(currentId);

  if (currentIndex === -1) {
    return { prevId: null, nextId: null };
  }

  return {
    prevId: currentIndex > 0 ? documentIds[currentIndex - 1] : null,
    nextId:
      currentIndex < documentIds.length - 1
        ? documentIds[currentIndex + 1]
        : null,
  };
};
